
import { defineComponent } from 'vue'
import { ElConfigProvider } from 'element-plus'

import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default defineComponent({
  name: 'App',
  components: {
    ElConfigProvider
  },
  setup() {
    return {
      locale: zhCn,
      aLocale: zh_CN
    }
  }
})
